var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 41,
    viewBox: "0 0 45 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0148 38.2589C38.0148 38.7893 37.8041 39.298 37.429 39.6731C37.0539 40.0482 36.5452 40.2589 36.0148 40.2589H8.01477C7.48434 40.2589 6.97563 40.0482 6.60056 39.6731C6.22548 39.298 6.01477 38.7893 6.01477 38.2589V20.2589H0.0147705L20.6688 1.48287C21.037 1.14783 21.5169 0.962158 22.0148 0.962158C22.5126 0.962158 22.9925 1.14783 23.3608 1.48287L44.0148 20.2589H38.0148V38.2589ZM20.0148 24.2589V36.2589H24.0148V24.2589H20.0148Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.c565d25a4db5eeb8f02f6c62863319f9.svg";
export { ForwardRef as ReactComponent };